/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OAuthAppTypeEnum } from './oAuthAppTypeEnum';
import { OAuthAppInventoryMetadata } from './oAuthAppInventoryMetadata';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { OAuthAppAwsAccountCategoryEnum } from './oAuthAppAwsAccountCategoryEnum';
import { OAuthAppCreationTypeEnum } from './oAuthAppCreationTypeEnum';


export interface OAuthAppInventorySpec { 
    name?: string;
    description?: string;
    secret_manager_path?: string;
    account_type?: OAuthAppAwsAccountCategoryEnum;
    metadata?: OAuthAppInventoryMetadata;
    secret_rotation_timestamp?: Date;
    secret_rotated_by?: string;
    app_id: string;
    org_id: string;
    service_type: ServiceTypeEnum;
    creation_type: OAuthAppCreationTypeEnum;
    type: OAuthAppTypeEnum;
}
export namespace OAuthAppInventorySpec {
}


